import { TrackingPixel } from "@brandclub/common-ui";

export interface UserProfile {
  email: string;
  email_verified: "true" | "false";
  family_name: string;
  given_name: string;
  name: string;
  phone_number_verified: "false" | "true";
  picture: string;
  sub: string;
  referralCode: string;
  referralStatus: "active" | "inactive";
  referralMax: number;
  username: string;
  userPoolType: "brand" | "consumer";
  phoneNumber?: string;
  phoneNumberVerified: boolean;
  createdAt: string;
  extendedAttributes: any;
  oauthUserId: string;
  updatedAt: string;
  userId: string;
  gender?: string;
  birthdate?: string;
}

export interface IAppAuthConfig {
  userPoolId: string;
  userPoolClientId: string;
  identityPoolId: string;
  signInDomain: string;
  region: string;
}

export enum StoreBrandingType {
  CustomDTCStore = "CustomDTCStore",
  CustomStore = "CustomStore",
  BrandStore = "BrandStore",
  UniversalStore = "UniversalStore",
}

export interface IAppDomainConfig {
  domainName: string;
  brandId: number;
  brandName: string;
  storeBrandingType: StoreBrandingType;
  customShopDomainName?: string;
  mobileAppLink?: string;
  checkoutAllowedOfferType?: "firstPartyOnly" | "thirdPartyOnly" | "both";
  pixels?: TrackingPixel[];
  abTestingTreatmentResults?: {
    [experimentName: string]: {
      treatment: string;
      config?: string;
    };
  };
}

export interface BrandAppConfig {
  appConfigId: string;
  version: string;
  appName: string;
  companyId: string;
  appStatus: string;
  brandIds: number[];
  brandclubIds: string[];
  retailerIds: number[];
  checkoutBrandId: number;
  mobileAppConfig?: any;
  updatedBy: string;
  updatedTime: string;
  publishedVersion: number;
  appId: string;
  appType: string;
  appStoreUrl: string;
  playStoreUrl: string;
  configId: string;
  apps: {
    appConfigId: string;
    appDescription: string;
    appId: string;
    appName: string;
    appSlug: string;
    appStatus: string;
    appType: string;
  }[];
  branchIOConfig: {
    webAppBranchLink: string;
    mobileAppBranchLink: string;
    accessToken: string;
    key: string;
    appId: string;
  };
  socialLinks?: any;
  membershipPageConfig?: {
    surveyPicture?: string;
    logoPicture?: string;
  };
  checkoutPageConfig?: {
    logoPicture?: string;
  };
}

export interface AppConfig {
  authConfig: IAppAuthConfig;
  domainConfig: IAppDomainConfig;
}
